<!--
  ~ Copyright (c) Worldline 2022.
  -->

<!DOCTYPE html>

<div id="modal-timeout">
    <div class="modal-header">
        <h4 class="popup-title">{{ 'timeout.title' | translate }}</h4>
    </div>
    <div class="modal-body">
        <p>{{ 'timeout.explanation' | translate }}</p>
    </div>
    <div class="modal-footer" *ngIf="canRedirect">
        <button class="certificateClose" (click)="error()">{{ 'timeout.quit' | translate }}</button>
    </div>
</div>
